import { call, put, takeEvery } from 'redux-saga/effects';

import { UserPermissions } from 'entities/user';
import { EntityWithId, IClient, simpleClient } from 'services/apiGatewayClient';
import { Actions } from 'services/authentication/ducks';
import { Actions as NotificationActions } from 'core/ui/notificationBar';
import { Types as AuthTypes } from './../ducks/types';
import i18next from 'i18next';

function* populatePermissions(client: IClient<UserPermissions>) {
  try {
    const permissions: EntityWithId<UserPermissions> = yield call([client, 'get'], '/users/me');
    yield put(Actions.populatePermissions(permissions.entity));
  } catch (e) {
    yield put(NotificationActions.customNotification('error', i18next.t('common:errors.loadPermissionFailure')));
  }
}

export function getUserPermissions(client: IClient<UserPermissions> = simpleClient<UserPermissions>()) {
  return function*() {
    yield takeEvery(AuthTypes.AMPLIFY_SIGNED_IN, populatePermissions, client);
  };
}
